import request from '@/utils/request'
import store from '@/store'
const url = store.getters.getPostUrl;
export default {
  getList(param) {
  	return request({
  		url: url + '/inspection/record/maintenanceList',
  		method: 'post',
      data: param,
  	})
  },
  getExcel(param) {
  	return request({
  		url: url + '/inspection/record/maintenanceExcel',
  		method: 'post',
      data: param,
  	})
  },
	getmaintenanceById(param) {
		return request({
			url: url + '/inspection/record/getmaintenanceById',
			method: 'get',
			params:param,
		})
	},
}



// WEBPACK FOOTER //
// ./src/assets/js/maintenance/maintenance.js